var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPinIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3912 3.99921L12.3912 5.99921M9.05786 13.3325H14.3912M3.72453 10.6659L3.05786 13.3325L5.72453 12.6659L13.4485 4.94188C13.6985 4.69184 13.8389 4.35277 13.8389 3.99921C13.8389 3.64566 13.6985 3.30658 13.4485 3.05655L13.3339 2.94188C13.0838 2.69192 12.7447 2.5515 12.3912 2.5515C12.0376 2.5515 11.6986 2.69192 11.4485 2.94188L3.72453 10.6659Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPinIcon);
export default __webpack_public_path__ + "static/media/edit_pin_icon.37f99b6b3b5ca2c071be5f727aaf19f9.svg";
export { ForwardRef as ReactComponent };